export enum TRANSFER_SERVICES {
  MYLOBY = "MYLOBY",
  ACSES = "ACSES",
  SNAPACCESS = "SNAPACCESS",
}
